module.exports = __webpack_public_path__ + "static/media/chandigarhwebp.e695bd70.webp";